document.addEventListener("DOMContentLoaded", () => {
    const sticky = document.getElementById("pf-sticky-cart");
    const stickyButton = document.getElementById("pfStickyButton");
    const stickyPrice = document.querySelector(".pf-sticky-cart__price");

    if (!sticky) return;

    // Asegurarse de que arranque oculto al cargar la página
    sticky.classList.remove("show");

    function updateStickyPrice() {
        const checkedTier = document.querySelector('.bd-tier input[type="radio"]:checked');
        if (!checkedTier) return;

        const tier = checkedTier.closest(".bd-tier");
        if (!tier) return;

        const price = tier.querySelector(".bd-tier__price");
        if (!price) return;

        if (stickyPrice) {
            stickyPrice.textContent = price.textContent.trim();
        }
    }

    function updateSticky() {
        updateStickyPrice();

        // Buscamos el contenedor principal de producto (hero + fotos + tiers de compra)
        const mainProduct = document.querySelector(
            '.product, .product-section, [id*="MainProduct"], .pf-hero-copy-block'
        );

        if (mainProduct) {
            const rect = mainProduct.getBoundingClientRect();
            // Aparece únicamente cuando el bloque principal ya pasó y scrolleaste al menos 400px abajo de él
            if (rect.bottom < -200) {
                sticky.classList.add("show");
            } else {
                sticky.classList.remove("show");
            }
        } else {
            // Respaldo por altura de pantalla: aparece recién tras bajar 1.5 pantallas completas
            if (window.scrollY > window.innerHeight * 1.5) {
                sticky.classList.add("show");
            } else {
                sticky.classList.remove("show");
            }
        }
    }

    window.addEventListener("scroll", updateSticky, { passive: true });
    window.addEventListener("resize", updateSticky);

    // Ejecución inicial
    updateSticky();

    const observer = new MutationObserver(() => {
        updateStickyPrice();
    });

    document.querySelectorAll(".bd-tier__price").forEach(price => {
        observer.observe(price, {
            childList: true,
            subtree: true,
            characterData: true
        });
    });

    updateStickyPrice();

    // =====================================================
    // STICKY CART → AGREGAR PRODUCTO → ABRIR RELEASIT
    // =====================================================
    if (stickyButton) {
        stickyButton.addEventListener("click", async () => {
            const form = document.querySelector('form[data-type="add-to-cart-form"]');
            if (!form) return;

            const formData = new FormData(form);

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error('Error agregando al carrito');
                }

                sessionStorage.setItem('openReleasitAfterCart', 'true');
                window.location.href = '/cart';

            } catch (e) {
                console.error(e);
            }
        });
    }

    if (sessionStorage.getItem('openReleasitAfterCart') === 'true') {
        sessionStorage.removeItem('openReleasitAfterCart');

        let attempts = 0;
        const maxAttempts = 20;

        const openReleasit = setInterval(() => {
            const checkoutButton = document.getElementById('checkout');
            attempts++;

            if (checkoutButton) {
                clearInterval(openReleasit);
                setTimeout(() => {
                    checkoutButton.click();
                }, 300);
            }

            if (attempts >= maxAttempts) {
                clearInterval(openReleasit);
            }
        }, 100);
    }
});